import type { BTLeaf } from "../types";
import type { LeafContext, TickResult } from "./context";

export function tickMarkSuccess(
  ctx: LeafContext,
  _node: Extract<BTLeaf, { kind: "markSuccess" }>
): TickResult {
  void _node;
  ctx.setOutcome("success");
  return "success";
}

export function tickMarkFailure(
  ctx: LeafContext,
  _node: Extract<BTLeaf, { kind: "markFailure" }>
): TickResult {
  void _node;
  ctx.setOutcome("failure");
  return "success";
}
